import useMarginLevel from "./useMarginLevel";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notificationsSlice } from "../../Notifications/notificationsReducer";
import { getIsShowAccountEventIndicator } from "../../Notifications/notificationsSelectors";

const MARGIN_LEVEL_INDICATOR_THRESHOLDS = [100, 75];

function useMarginLevelWatch() {
    const { isInited: isMarginLevelInited, marginLevel } = useMarginLevel();
    const marginLevelPrevRef = useRef<number>();
    const dispatch = useDispatch();
    const isAlreadyShownAccountEventIndicator = useSelector(getIsShowAccountEventIndicator);

    useEffect(() => {
        if (!isMarginLevelInited) {
            return;
        }

        const isFirstMarginLevelCheck = !marginLevelPrevRef.current;
        const marginCallTopThreshold = MARGIN_LEVEL_INDICATOR_THRESHOLDS[0];
        let isShowAccountEventIndicatorNow = false;

        if (isFirstMarginLevelCheck) {
            if (marginLevel < marginCallTopThreshold) {
                isShowAccountEventIndicatorNow = true;
            }
        } else {
            for (let i = 0; i < MARGIN_LEVEL_INDICATOR_THRESHOLDS.length; i++) {
                const currentThreshold = MARGIN_LEVEL_INDICATOR_THRESHOLDS[i];
                if (marginLevel < currentThreshold && marginLevelPrevRef.current > currentThreshold) {
                    isShowAccountEventIndicatorNow = true;
                    break;
                }
            }
        }

        if (isAlreadyShownAccountEventIndicator && marginLevel > marginCallTopThreshold) {
            dispatch(notificationsSlice.actions.setIsShowAccountEventIndicatorAction(false));
        }

        if (!isAlreadyShownAccountEventIndicator && isShowAccountEventIndicatorNow) {
            dispatch(notificationsSlice.actions.setIsShowAccountEventIndicatorAction(true));
        }

        marginLevelPrevRef.current = marginLevel;
    }, [
        dispatch,
        isAlreadyShownAccountEventIndicator,
        isMarginLevelInited,
        marginLevel,
    ]);
}

export default useMarginLevelWatch;
